import { CommonUtilities } from "commonUtils";
import { useEffect, useState } from "react";
import Drawer from 'react-modern-drawer';
import projectServices from "./projectServices";
import Pagination from "components/Common/newPagination";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import CommonSearch from "components/commonSearch/CommonSearch";

export default function ProjectsToContract(param: any) {

    const [totalRows, setTotalRows] = useState(0);
    let [selectArray, setSelectArray] = useState<any>([]);
    const [gridHeader, initGridHeader] = useState<any>([]);
    const [ProjectList, initProjectList] = useState<any>([]);
    const [GridOriginal, initGridOriginal] = useState<any>([]);
    const [GridOrdering, initGridOrdering] = useState<any>([]);
    const [gridVisibility, initGridVisibility] = useState<any>([]);
    let [selectedContract, initselectedContract] = useState<any>([]);

    const ProjectsToContractChange = () => { param.ProjectsToContractChange(); }

    var payload = { export: 0, pageNumber: 1, pageSize: 10 }

    useEffect(() => {
        selectedContract = param?.contractDetails
        initselectedContract(selectedContract)

        projectList();
        selectArray = []
        setSelectArray(selectArray)
    }, [param]);


    const projectList = () => {
        projectServices.ProjectListing(payload).then((res: any) => {
            initProjectList(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));
            setTotalRows(res.totalRows)

            console.log(CommonUtilities.relativeDataRemapping(res.data, res.headers.original))
            initGridHeader(CommonUtilities.reMap(res.headers.display));
            initGridVisibility(CommonUtilities.reMap(res.headers.visible));
            initGridOriginal(CommonUtilities.reMap(res.headers.original));
            initGridOrdering(reMapOrdering(res.headers.original))
        })
    }

    const reMapOrdering = (mapReturn: any) => {
        var tempmapReturn: any[] = [];
        Object.entries(mapReturn).forEach(([key, value]) => { tempmapReturn.push(0) });
        return tempmapReturn;
    }

    const reMapOrderingSet = (index: any) => {

        for (var i = 0; i < GridOrdering.length; i++) {
            GridOrdering[i] = 0;
        }

        GridOrdering[index] = 1;
        initGridOrdering((existingValues: any) => ([...GridOrdering]));

        projectList();
    }

    const handleNameOnChange = (e: any) => {

    }

    const toggleSelection = (e: any) => {
        console.log(e)
        console.log(ProjectList)
        console.log(ProjectList[e])


        const find_array = selectArray.findIndex((value: any) => value == e)
        if (find_array !== -1) {
            const updatedArray = [...selectArray];
            updatedArray.splice(find_array, 1);
            setSelectArray(updatedArray);
        } else {


            const updated_Array = [...selectArray];
            updated_Array.push(e)
            setSelectArray(updated_Array);
        }

        console.log(find_array)
        console.log(selectArray)
    }

    console.log(param)
    let [copyStatus, setCopyStatus] = useState(false)
    const CopyProject = () => {
        copyStatus = true;
        setCopyStatus(copyStatus)
    }

    const Confirmation = (e: any) => {
        console.log(e)
        if (e === 1) {
            //true
            var payload = { actionBy: "contract", assetCode: selectedContract?.contractRefNum, assetType: "contract", projectList: selectedContract }

            projectServices.copyContractProjects(payload).then((respond: any) => {
                projectList();
            })
        }
        copyStatus = false;
        setCopyStatus(copyStatus)
    }

    const SearchForHandle = (e: any, sts: any) => {
        console.log(e)
        console.log(sts)

        if ((sts === true)) {
            payload = {payload,...e}
            projectList();
        }
    }

    return (
        <>

            <Drawer open={param.ProjectsToContractOpen} onClose={ProjectsToContractChange} direction='right' className='react-drawer' size={1000}>

                <div className="landing ws-7 pull-right">

                    <div className="box-header bg-blue">
                        <h2 className="ws-12">Project List - 12 records found</h2>
                    </div>


                    <div className="ws-12 pm">

                        <div className='ws-12 mt mbl '>
                            <CommonSearch SearchForHandle={SearchForHandle} type="projectGrid" title="projectGrid" width="ws-12 pull-left" />
                        </div>

                        <div className="ws-12  box">

                            {totalRows == 0 && <div className="alert alert-info mt">No records to display</div>}

                            {totalRows > 0 && gridHeader && <table className="newTable">
                                <thead>
                                    <tr>
                                        <th ></th>
                                        {
                                            gridHeader?.map((values: any, index: any) => {
                                                if (values !== 'totalRow' && gridVisibility[index] === 1) {
                                                    return (<>
                                                        <th >
                                                            <span >{values} </span>

                                                            <a className="pl" onClick={() => reMapOrderingSet(index)}>
                                                                {GridOrdering[index] === 0 && <span style={{ fontSize: "10px" }}>↕</span>}
                                                                {GridOrdering[index] === 1 && <span>↑</span>}
                                                                {GridOrdering[index] === 2 && <span>↓</span>}
                                                                <span className="hide"> {GridOrdering[index]} </span>
                                                            </a>
                                                        </th>
                                                    </>)
                                                }
                                            })
                                        }

                                    </tr>
                                </thead>

                                <tbody>

                                    {
                                        ProjectList?.map((Datavalues: any, index: any) => {
                                            return (
                                                <tr>
                                                    <td> <input type="checkbox" onChange={() => toggleSelection(index)} value={selectArray.filter((value: any) => value == index)} /> </td>

                                                    {GridOriginal?.map((values: any, index: any) => {
                                                        if (values !== 'totalRow' && gridVisibility[index] === 1) {
                                                            return (
                                                                <td>
                                                                    {
                                                                        (() => {

                                                                            if (values === "projectType") {
                                                                                return (
                                                                                    Datavalues[values]?.toString().split(',')?.map((valueName: any) => {
                                                                                        return (

                                                                                            <a className={"btn-xs ms text-center"}
                                                                                                style={{
                                                                                                    background: CommonUtilities.lookUpTypeList('projectTag', valueName, 'bgColor'),
                                                                                                    color: CommonUtilities.lookUpTypeList('projectTag', valueName, 'fontColor')
                                                                                                }} >
                                                                                                {valueName}
                                                                                            </a>
                                                                                        )
                                                                                    })
                                                                                )

                                                                            }

                                                                        })()
                                                                    }

                                                                    <span className={values !== "projectType" ? "" : "hide"}>  {Datavalues[values]}  </span>

                                                                </td>
                                                            )
                                                        }
                                                    })}

                                                </tr>
                                            )
                                        })
                                    }

                                </tbody>

                            </table>}

                            {totalRows > 0 && <div className="box-footer">

                                {(() => {

                                    if (totalRows > 1 && totalRows > 10) {
                                        return <Pagination onPageChange={handleNameOnChange} totalRow={totalRows} />
                                    }

                                    if (totalRows === 0) {
                                        return <div className="alert alert-info mt mrl mbl"> No data to display</div>
                                    }
                                })()}
                            </div>}
                        </div>
                    </div>

                    <div className="box footer pm noBorderRadius">
                        {totalRows > 0 && <button className="icon-btn edit pull-right width100 height35" disabled={selectArray?.length == 0} onClick={CopyProject}>
                            <i className="icon-files"></i> <span ng-show="flagCopy"> Copy</span>
                        </button>}

                        <button className="icon-btn delete pull-right width80 height35" onClick={ProjectsToContractChange}>Close  </button>

                    </div>

                    {
                        (() => {

                            if (copyStatus) {
                                return <DeleteDialogueBox param={copyStatus} message={"copy these projects to contract: " + selectedContract?.contractRefNum} onChange={Confirmation} />
                            }
                        })()
                    }

                </div>

            </Drawer>

        </>
    )


}




